export const getAiFeatureFlags = (organization) => ({
  aiCompanionEnabled: organization?.ai_companion_enabled === true,
  lessonTranscriptVisible: organization?.lesson_transcript_visible === true,
});
